function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { FIELD_TYPES } from "constants/template-field-type";
import TwoThirdsTextAndAssetConfig from "segments/desktop/text-and-asset/layouts/two-thirds-text-and-asset/two-thirds-text-and-asset-config";
const _TwoThirdsTextAndAssetConfig_fields_fullParagraph_fields = TwoThirdsTextAndAssetConfig.fields.fullParagraph.fields, { titleColor } = _TwoThirdsTextAndAssetConfig_fields_fullParagraph_fields, fullParagraphFields = _object_without_properties(_TwoThirdsTextAndAssetConfig_fields_fullParagraph_fields, [
    "titleColor"
]); // title color is controlled from theme
const textAndAssetFields = _object_spread_props(_object_spread({}, TwoThirdsTextAndAssetConfig.fields), {
    asset: _object_spread_props(_object_spread({}, TwoThirdsTextAndAssetConfig.fields.asset), {
        fields: _object_spread_props(_object_spread({}, TwoThirdsTextAndAssetConfig.fields.asset.fields), {
            useWindowMask: {
                type: FIELD_TYPES.BOOLEAN,
                label: "Use window mask"
            }
        })
    }),
    fullParagraph: _object_spread_props(_object_spread({}, TwoThirdsTextAndAssetConfig.fields.fullParagraph), {
        fields: _object_spread({}, fullParagraphFields)
    })
});
export default {
    type: FIELD_TYPES.NESTED,
    label: "Building Blocks",
    fields: {
        buildingBlocksTabsTheme: {
            type: FIELD_TYPES.COLOR_PICKER,
            label: "Theme"
        },
        tabs: {
            type: FIELD_TYPES.MULTIPLE_NESTED,
            label: "Tabs",
            maxLimit: 8,
            nestedConfig: {
                type: FIELD_TYPES.NESTED,
                fields: {
                    tabLabel: {
                        type: FIELD_TYPES.TEXT,
                        label: "Tab Label",
                        translatable: true
                    },
                    // Should be added after cloudinary-service.js is refactored
                    // tabIcon: {
                    //   type: FIELD_TYPES.GALLERY,
                    //   defaultImagesKeys: [],
                    //   label: "Select an Icon"
                    // },
                    textAndAsset: {
                        type: FIELD_TYPES.NESTED,
                        label: "Text and asset",
                        fields: textAndAssetFields
                    }
                }
            }
        }
    }
};
